/**
 * Created by wuhuping on 2017/5/22.
 */
import validator from './validator'
import store from '../store'
import statisticalSDK from './statisticalSDK'
import deviceInfoHelper from './deviceInfo'
import channel from './channel'
import locationHelper from './locationHelper'
export default {
  commonHeaderWithPageName(pageName) {
    let headers = {
      'topic': 'newtrace',
      'sysId': 'xyqb03',
      'pageId': pageName,
      'eventId': 'button',
      'network_name': this.netInfo().netName,
      'network_type': this.netInfo().netType
    };
    return headers;
  },
  uuid() {
    let uuid = 'nosign'
    let deviceInfo = deviceInfoHelper.fetchDeviceInfo()
    if (deviceInfo) {
      deviceInfo = JSON.parse(deviceInfo)
      if (deviceInfo.uuid) {
        uuid = deviceInfo.uuid
      }
    }
    return uuid;
  },
  channelNo() {
    let channelNo = channel.chanNo()
    let deviceInfo = deviceInfoHelper.fetchDeviceInfo()
    if (deviceInfo) {
      deviceInfo = JSON.parse(deviceInfo)
      if (deviceInfo.chanNo) {
        channelNo = deviceInfo.chanNo
      }
    }
    if (!channelNo || !channelNo.length) {
      channelNo = 'nosign'
    }
    return channelNo;
  },
  version() {
    let version = 'nosign'
    let deviceInfo = deviceInfoHelper.fetchDeviceInfo()
    if (deviceInfo) {
      deviceInfo = JSON.parse(deviceInfo)
      if (deviceInfo.appVersion) {
        version = deviceInfo.appVersion
      }
    }
    return version;
  },
  location(need, callback) {
    if (!need) {
      let locationInfo = 'notrack__notrack'
      callback(locationInfo);
      return;
    }
    locationHelper.latitude(function (latitude) {
      locationHelper.longitude(function (longitude) {
        let locationInfo = longitude + '__' + latitude;
        if (!latitude || !longitude) {
          locationInfo = 'nosign__nosign'
        }
        // android6.0以下不统计
        if (deviceInfoHelper.isAndroidDevice()) {
          let deviceInfo = deviceInfoHelper.fetchDeviceInfo()
          if (deviceInfo) {
            deviceInfo = JSON.parse(deviceInfo)
            if (deviceInfo.osversion && deviceInfo.osversion < '6') {
              locationInfo = 'notrack__notrack'
            }
          }
        }
        callback(locationInfo);
      })
    })
  },
  changeLbs(lng, lat, callback) {
    // 创建地址解析器实例
    var myGeo = new BMap.Geocoder()
    var point1 = new BMap.Point(lng, lat)
    myGeo.getLocation(point1, function (rs) {
      var addComp = rs.addressComponents
      var newLocation = {
        province: addComp.province,
        city: addComp.city,
        district: addComp.district,
        street: addComp.street,
        streetNumber: addComp.streetNumber
      }
      callback(newLocation)
    })
  },
  // 获取国家、省份、城市名称
  fetchAddress(callback) {
    locationHelper.latitude(function (lat) {
      locationHelper.longitude(function (lon) {
        let longitude = longitude ? lon : null
        let latitude = latitude ? lat : null
        let locationInfo
        if (!latitude || !longitude) {
          locationInfo = 'nosign__nosign__nosign'
          callback(locationInfo)
        } else {
          this.changeLbs(longitude, latitude, (res) => {
            locationInfo = '中国' + '__' + res.province + '__' + res.city
            callback(locationInfo)
          })
        }
      })
    })
  },
  // 运营商
  operater() {
    let operater = 'nosign'
    let deviceInfo = deviceInfoHelper.fetchDeviceInfo()
    if (deviceInfo) {
      deviceInfo = JSON.parse(deviceInfo)
      if (deviceInfo.operater) {
        operater = deviceInfo.operater
      }
    }
    return operater
  },
  // 网络名称、类型
  netInfo() {
    let netName, netType
    let deviceInfo = deviceInfoHelper.fetchDeviceInfo()
    if (deviceInfo && deviceInfo['networkName']) {
      deviceInfo = JSON.parse(deviceInfo)
      netName = deviceInfo.networkName
      netType = deviceInfo.networkType
    } else {
      netName = 'nosign'
      netType = channel.getNetworkType()
    }
    return {
      netName: netName,
      netType: netType
    }
  },
  baseStats(callback) {
    let childChan = 'nosign'
    let content
    let that = this
    let startNo = window.sessionStorage.getItem('deviceStartNo')
    this.fetchAddress(address => {
      statisticalSDK.get_ip(function () {
        let deviceInfo = deviceInfoHelper.fetchDeviceInfo()
        deviceInfo = JSON.parse(deviceInfo)
        // 渠道号chanNo;app版本appVersion;手机型号mobileType;设备唯一标识号imei;uuid;操作系统ostype;系统版本osversion;设备物理地址mac;androidId;手机制造商manufacturer;分辨率resolution;运营商operater;idfa;是否rootrootStatus;网络名称networkName;网络类型（unknown,wifi,other,2g,3g,4g）netType;运营商
        // 启动编号_设备品牌_操作系统_操作系统版本_设备ID_设备型号_分辨率_IP_APP版本_主渠道_子渠道_国家_省份_城市_运营商
        if (deviceInfo) {
          content = startNo + '__' + deviceInfo['manufacturer'] + '__' + channel.detectOS().system + '__' + deviceInfo.osversion + '__' + deviceInfo.uuid + '__' + deviceInfo.mobileType + '__' + statisticalSDK.resolution() + '__' + statisticalSDK.sIp() + '__' + that.version() + '__' + that.channelNo() + '__' + childChan + '__' + address + '__' + that.operater()
          callback(content)
        } else {
          content = startNo + '__nosign' + '__' + channel.detectOS().system + '__' + channel.detectOS().version + '__nosign__nosign__' + statisticalSDK.resolution() + '__' + statisticalSDK.sIp() + '__' + that.version() + '__' + that.channelNo() + '__' + childChan + '__' + address + '__' + that.operater()
          callback(content)
        }
      })
    })
  },
  // 基础模块 注册、登陆、忘记密码、实名认证、产品详情、个人中心、设置、常见问题
  baseModel(pageId, btnName, pageName, frist, second) {
    // 时间戳_手机号_经度__纬度_按键名称_数据渠道_页面名称_手机号输入框内值_来源
    let headers = this.commonHeaderWithPageName(pageId)
    let time = statisticalSDK.getTime()
    let channelNo = this.channelNo()
    let phone = 'NULL'
    if (store.getters.isLogin && store.getters.phone) {
      phone = store.getters.phone
    }
    this.location(true, (location) => {
      this.baseStats(res => {
        let content = res
        if (frist && second) {
          content += '__' + time + '__' + phone + '__' + location + '__' + btnName + '__' + channelNo + '__' + pageName + '__' + frist + '__' + second
        } else if (frist) {
          content += '__' + time + '__' + phone + '__' + location + '__' + btnName + '__' + channelNo + '__' + pageName + '__' + frist
        } else {
          content += '__' + time + '__' + phone + '__' + location + '__' + btnName + '__' + channelNo + '__' + pageName
        }
        statisticalSDK.statistical(headers, content)
      })
    })
  },
  // 首页
  homePageEventStatistical(btnName, pageId, pageName, prodId, prodName, orgId, orgName, prodSort, adId, adName, adUrl, adSort) {
    // 时间戳_手机号_经度__纬度_按键名称_数据渠道_页面名称_产品id_产品名称_机构id_机构名称_产品位置顺序_广告id_广告名称_广告url_广告顺序
    let headers = this.commonHeaderWithPageName(pageId)
    let time = statisticalSDK.getTime()
    let channelNo = this.channelNo()
    let phone = 'NULL'
    if (store.getters.isLogin && store.getters.phone) {
      phone = store.getters.phone
    }
    this.location(true, (location) => {
      this.baseStats(res => {
        let content = res
        if (prodId && !adId) {
          content += '__' + time + '__' + phone + '__' + location + '__' + btnName + '__' + channelNo + '__' + pageName + '__' + prodId + '__' + prodName + '__' + orgId + '__' + orgName + '__' + prodSort + '__notrack__notrack__notrack__notrack'
        } else if (prodId && adId) {
          content += '__' + time + '__' + phone + '__' + location + '__' + btnName + '__' + channelNo + '__' + pageName + '__notrack__notrack__notrack__notrack__notrack' + '__' + adId + '__' + adName + '__' + adUrl + '__' + adSort
        } else {
          content += '__' + time + '__' + phone + '__' + location + '__' + btnName + '__' + channelNo + '__' + pageName + '__notrack__notrack__notrack__notrack__notrack__notrack__notrack__notrack__notrack'
        }
        statisticalSDK.statistical(headers, content)
      })
    })
  },
  // 保险产品列表页
  insuranceListEventStatistical(btnName, tabName, prodId, prodName, orgId, orgName, prodSort) {
    // 时间戳_手机号_经度__纬度_按键名称_数据渠道_页面名称_标签按键名称_产品id_产品名称_机构id_机构名称_产品位置顺序
    let headers = this.commonHeaderWithPageName('insurance_allproduct')
    let time = statisticalSDK.getTime()
    let channelNo = this.channelNo()
    let pageName = '全部产品'
    let phone = 'NULL'
    if (store.getters.isLogin && store.getters.phone) {
      phone = store.getters.phone
    }
    this.location(true, (location) => {
      this.baseStats(res => {
        let content = res
        if (prodId) {
          content += '__' + time + '__' + phone + '__' + location + '__' + btnName + '__' + channelNo + '__' + pageName + '__' + tabName + '__' + prodId + '__' + prodName + '__' + orgId + '__' + orgName + '__' + prodSort
        } else {
          content += '__' + time + '__' + phone + '__' + location + '__' + btnName + '__' + channelNo + '__' + pageName + '__' + tabName + '__notrack__notrack__notrack__notrack__notrack'
        }
        statisticalSDK.statistical(headers, content)
      })
    })
  },
  // 我的贷款
  myLoanEventStatistical(btnName, pageId, pageName, prodId, prodName, orgId, orgName) {
    // 时间戳_手机号_经度__纬度_按键名称_数据渠道_页面名称_产品id_产品名称_机构id_机构名称
    let headers = this.commonHeaderWithPageName(pageId)
    let time = statisticalSDK.getTime()
    let channelNo = this.channelNo()
    let phone = 'NULL'
    if (store.getters.isLogin && store.getters.phone) {
      phone = store.getters.phone
    }
    this.location(true, (location) => {
      this.baseStats(res => {
        let content = res
        if (prodId) {
          content += '__' + time + '__' + phone + '__' + location + '__' + btnName + '__' + channelNo + '__' + pageName + '__' + prodId + '__' + prodName + '__' + orgId + '__' + orgName
        } else {
          content += '__' + time + '__' + phone + '__' + location + '__' + btnName + '__' + channelNo + '__' + pageName + '__notrack__notrack__notrack__notrack'
        }
        statisticalSDK.statistical(headers, content)
      })
    })
  },
  // 公告
  announcementEventStatistical(pageId, pageName, btnName, frist, second, third) {
    // 时间戳_手机号_经度__纬度_按键名称_数据渠道_页面名称_资讯id_资讯标题_资讯顺序
    let headers = this.commonHeaderWithPageName(pageId)
    let time = statisticalSDK.getTime()
    let channelNo = this.channelNo()
    let phone = 'NULL'
    if (store.getters.isLogin && store.getters.phone) {
      phone = store.getters.phone
    }
    this.location(true, (location) => {
      this.baseStats(res => {
        let content = res
        content += '__' + time + '__' + phone + '__' + location + '__' + btnName + '__' + channelNo + '__' + pageName + '__' + frist + '__' + second + '__' + third
        statisticalSDK.statistical(headers, content)
      })
    })
  },
  // 营销弹窗/福利banner
  marketingEventStatistical(pageId, pageName, btnName, frist, second, third) {
    // 时间戳_手机号_经度__纬度_按键名称_数据渠道_页面名称_广告id_广告名称_广告url
    let headers = this.commonHeaderWithPageName(pageId)
    let time = statisticalSDK.getTime()
    let channelNo = this.channelNo()
    let phone = 'NULL'
    if (store.getters.isLogin && store.getters.phone) {
      phone = store.getters.phone
    }
    this.location(true, (location) => {
      this.baseStats(res => {
        let content = res
        content += '__' + time + '__' + phone + '__' + location + '__' + btnName + '__' + channelNo + '__' + pageName + '__' + frist + '__' + second + '__' + third
        statisticalSDK.statistical(headers, content)
      })
    })
  },
  // 进入页面、离开页面 埋点
  beforeOrLiveRouteStatistical(pushPageName, pageName) {
    // 进入页面时间_离开页面时间_跳转页面名称_跳转页面路由_用户ID_手机号_经度_维度_页面名称_页面路由
    let headers = this.commonHeaderWithPageName(pageName)
    let cusNo = 'nosign'
    let phone = 'NULL'
    if (store.getters.isLogin && store.getters.phone) {
      phone = store.getters.phone
      cusNo = store.getters.userId
    }
    let openTime, liveTime
    if (pushPageName === 'notrack') {
      openTime = statisticalSDK.getTime()
      liveTime = 'notrack'
    } else {
      openTime = 'notrack'
      liveTime = statisticalSDK.getTime()
    }
    let routerName = pageName
    this.location(true, (location) => {
      let content = openTime + '__' + liveTime + '__' + pushPageName + '__' + pushPageName + '__' + cusNo + '__' + phone + '__' + location + '__' + pageName + '__' + routerName
      statisticalSDK.statistical(headers, content)
    })
  }
}



// WEBPACK FOOTER //
// ./src/tools/statisticalHelper.js